import SwalCustom from './swal-custom'

// Both mean the employee was saved in HRMS while the push to Lark did not go through, so the save
// is a partial success rather than a failure (Meegle 15024898). They are separate cases with their
// own copy: SKIPPED names the multi-org cause, FAILED covers a sync failure with no known cause.
export const LARK_SYNC_SKIPPED_MSG = 'LARK_SYNC_SKIPPED_MULTIPLE_DEPARTMENTS'
export const LARK_SYNC_FAILED_MSG = 'FAILED_TO_SYNC_LARK'

// Resources are fetched from the translation service at runtime, so a key that is not registered
// there yet renders as its own name. Drop every fallback once all four keys exist on the hrms
// platform.
export const LARK_SYNC_COPY = {
  [LARK_SYNC_SKIPPED_MSG]: {
    title: 'hrms_pim_title_lark_sync_modal',
    titleFallback: 'HRMS Updated, but Lark Sync Failed!',
    subTitle: 'hrms_pim_sub_title_lark_sync_modal',
    subTitleFallback:
      "This employee's data has been successfully updated in HRMS. However, it could not be synced to Lark because this employee belongs to more than one organization structure. Please update this field in Lark manually."
  },
  [LARK_SYNC_FAILED_MSG]: {
    title: 'hrms_pim_title_lark_sync_failed_modal',
    titleFallback: 'HRMS Updated, but Lark Sync Failed!',
    subTitle: 'hrms_pim_sub_title_lark_sync_failed_modal',
    subTitleFallback:
      "This employee's data has been successfully updated in HRMS. However, it could not be synced to Lark. Please update this field in Lark manually."
  }
}

export const isLarkSyncWarning = (msg) => Boolean(LARK_SYNC_COPY[msg])

export default function SwalLarkSyncWarning(t, msg) {
  const copy = LARK_SYNC_COPY[msg] ?? LARK_SYNC_COPY[LARK_SYNC_FAILED_MSG]

  return SwalCustom({
    imageWarning: true,
    title: t(copy.title, { defaultValue: copy.titleFallback }),
    text: t(copy.subTitle, { defaultValue: copy.subTitleFallback }),
    confirmButtonColor: '#2c5dfe',
    confirmButtonText: 'Got It'
  })
}
